module.exports = __webpack_public_path__ + "media/images/countrysquared/gh-48be56523a8af8a3ba47e4778161ba96.svg";